/**
 * @file
 * @copyright  2017 Subscribe-HR
 */

import Field from './Field';

/**
 * Subscribe-HR entity string field
 */
export default class Attachment extends Field {

}



// WEBPACK FOOTER //
// ./src/client/common/js-subscribe-sdk/lib/Fields/Attachment.js